export const fr = {
  nav: {
    home: 'Accueil',
    for_companies: 'Pour les entreprises',
    for_nonprofits: 'Pour les associations',
    resources: 'Ressources',
    virtual_volunteering_tips: 'Conseils pour le bénévolat virtuel',
    case_studies: 'Études de cas',
    all_events: 'Activités de bénévolat',
    gallery: 'Galerie',
    my_events: 'Mes demandes et activités de bénévolat',
    volunteer_activity: 'Mon Bénévolat',
    all_requests: 'Toutes Les Demandes',
    impact: 'Impact',
    employees: 'Employés',
    help: 'Aide',
    company_settings: "Paramètres de l'entreprise",
    account_settings: 'Paramètres du compte',
    log_in: 'Se connecter',
    log_out: 'Se déconnecter',
    greenshield: 'L’Expérience d’une GreenShield unifiée',
  },
}
